import styled from 'styled-components'

export const AuthenWrapper = styled.div`
   height: 100%;
   line-height: 22px;
   display: grid;
   grid-template-columns: 65% 35%;
   // grid-template-columns: repeat(2, 1fr);
   background-color: #fff;
   color: #000;
   .login__banner {
      margin: 24px 0px 24px 24px;
      border-radius: 16px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
   }
   .img1 {
      object-position: center center;
      // object-position: left center; căn sang trái
      object-fit: contain;
      width: 10%;
      max-width: 101px;
      height: auto;
      margin-bottom: 16px;
      margin-top: 16px;
   }
   .text_title {
      color: #1e1e1e;
      font-size: clamp(18px, 3vw, 32px);
      text-align: center;
      margin-bottom: 60px;
      margin-top: 32px;
   }
   .img2 {
      object-position: center center;
      // object-position: left center; căn sang trái
      object-fit: contain;
      width: 78%;
      height: auto;
      margin-bottom: 32px;
   }

   .login__content {
      background-color: #fff;

      justify-content: center;
      // background-color: ${(props) => props.theme.color.dark_2};
      padding: 0px 4px 60px 4px;
      display: flex;
      flex-direction: column;
   }
   .signup__content {
      background-color: #fff;
      // background-color: ${(props) => props.theme.color.dark_2};
      padding: 24px 16px 48px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
   }
   .ant-checkbox {
      &::after {
         border: none;
         color: #0d6efd;
      }
      .ant-checkbox-inner {
         border-radius: 4px;
         background-color: '#0d6efd';
         border: 1.5px solid #0d6efd;
         color: #0d6efd;
      }
      .ant-checkbox-checked .ant-checkbox-inner {
         background-color: '#0d6efd';
         border: 1.5px solid #0d6efd;
      }
   }
   a {
      color: #0d6efd;
      //  ${(props) => props.theme.color.primary};
   }
   .form__title {
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      color: #282828;
   }
   .form__desc {
      font-weight: 400;
      font-size: 13px;
      margin-top: 8px;
      color: #31394d80;
   }
   .form__desc2 {
      font-weight: 400;
      font-size: 13px;
      margin-top: 8px;
      color: #31394d80;
      text-align: left;
   }
   .ant-input-affix-wrapper {
      padding: 9px 16px;
      .ant-input-prefix {
         margin-right: 16px;
      }
      input {
         font-size: 14px;
         line-height: 22px;
      }
   }
   .ant-form-item-explain-error {
      text-align: start;
   }
   .ant-form-item {
      &:first-child {
         margin-bottom: 16px;
      }
      margin-bottom: 24px;
   }
   .ant-checkbox-wrapper {
      color: white;
   }
   @media (max-width: 767px) {
      grid-template-columns: auto;
      .login__banner {
         display: none;
      }
   }
`

export const SignupWrapper = styled.div`
   padding: 16px;
   padding-top: unset;
   text-align: center;
   .signup-content__form {
      max-width: 320px;
      margin-left: auto;
      margin-right: auto;
      .signup-form__content {
         margin-top: 8px;
         .signup-form__footer {
            color: white;
            margin: unset;
            display: flex;
            width: 100%;
            justify-content: space-between;
            .signin__link {
               margin-top: auto;
               margin-bottom: auto;
            }
         }
         .ant-form-item.signup-form__term {
            margin-top: 16px;
            margin-bottom: 16px;
            text-align: start;
         }
         .ant-form-item {
            margin-bottom: 8px;
         }
         .form-item__wrapper {
            .form-item__label {
               margin-bottom: 8px;
               color: #282828;
               text-align: start;
               font-weight: 600;
            }
         }
      }
   }
`

export const LoginWrapper = styled.div`
   background-color: ${(props) => props.theme.color.dark_2};
   padding: 16px;
   padding-top: unset;
   .login-content__body {
      display: flex;
      flex-direction: column;
      gap: 24px;
      max-width: 370px;
      margin-left: auto;
      margin-right: auto;
      .login-content__logo {
         text-align: center;
         img {
            width: auto;
            height: 100px;
         }
      }
      .login-content__form {
         text-align: center;
         .login-form__content {
            margin-top: 60px;
            padding: 0 24px;
         }
      }
   }
   .rememberMe2 {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size:13px;
      justify-content: space-between; !important
   }
      .rememberMe2  .ant-checkbox-checked .ant-checkbox-inner {
          background-color: #0d6efd !important;
       border-color: #0d6efd !important;
}
   
   .rememberMe {
      color: #0d6efd;
      font-size:13px;
   }
   .login-content__footer {
      text-align: center;
      margin-top: 140px;
      a {
         color: ${(props) => props.theme.color.primary};
      }
   }
`
